<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/finance'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
  />
</template>

<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { GLChartService } from "../../../_services/api/gl/gl-chart.service";

export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      validationSummary: [],
      formModel: {
        //  SetDefault: false,
        Code: "",
        Description: "",
        Inactive: true,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
        RecordId: "",
      },
      data: {
        title: "GL Reporting Group 1",
        pageRoute: "/gl-reporting-group-1",
        saveEndPoint: "GLGroup1",
        recordEndPoint: "GLGroup1",
        exportFileName: "GL Reporting Group 1 List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "GLGroup1",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "gl-reporting-group-1",
              mode: "review",
              idProperty: "Code",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/gl-reporting-group-1/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              dataField: "Code",
              allowHiding: false,
            },
            {
              screenField: "Name",
              dataField: "Description",
              label: "Description",
            },
            {
              screenField: "Date",
              dataField: "DateChanged",
              label: "Date Changed",
            },
            {
              dataField: "ChangedBy",
              label: "Changed By",
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: "0",
            },
          ],
          valueChangedEventListners: [],
        },
      },
      setLoading: false,
    };
  },
  computed: {
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
                onValueChanged: (e) => {
                  this.onActiveValueChanged(e);
                },
              },

              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "Code",
                dataField: "Code",
                required: true,
                allowUpdate: this.baseView.mode == "edit" ? false : true,
                isPrimaryKeyField: true,
                editorOptions: {
                  maxLength: 2,
                },
                validationRules: [
                  {
                    type: "custom",
                    validationCallback: (e) => {
                      e.rule.message = `Code only allow maximum length of 2 characters`;
                      return e.value.length < 3;
                    },
                  },
                ],
              },
              {
                screenField: "Name",
                label: { text: "Description" },
                required: true,
                editorOptions: {
                  maxLength: 25,
                },
              },
            ],
          },
        ],
      };

      return form;
    },
  },
  methods: {
    async onActiveValueChanged(e) {
      if (
        this.baseView.mode == "edit" &&
        e.value == false &&
        e.previousValue == true
      ) {
        this.setLoading = true;
        await GLChartService.getGLChartData(
          `GLGroup1Code eq '${this.formModel["Code"]}'`
        )
          .then((res) => {
            this.setLoading = false;

            if (res.data.value.length > 0) {
              this.formModel.Inactive = true;

              e.component.beginUpdate();
              e.component.option("value", true);
              e.component.endUpdate();

              this.validationSummary = [];
              this.validationSummary.push({
                message: `${this.formModel["Description"]} is associated with GL Account records. This may not be marked inactive until it is no longer associated with GL Account records.`,
              });
              this.validationSummary.push({
                message: `Tip: To identify the associated GL Account use the filters in the GL Accounts list.`,
              });
            }
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });
      }
    },
  },
};
</script>
